<sc-flex vertical fitHeight stretchContent>

  <sc-dialog-title>
    <sc-dictionary-label [dictionaryKey]="titleDictionaryKey"></sc-dictionary-label>
  </sc-dialog-title>

  <sc-padding>
    @if ((clientStatusService?.isMobile && registerEntranceLeaveData?.readOnlyDetailsMobile != null) || (!clientStatusService?.isMobile && registerEntranceLeaveData?.readOnlyDetailsDefault != null)) {
      <app-transport-details [transport]="registerEntranceLeaveData?.transport"
      [layout]="clientStatusService?.isMobile ? registerEntranceLeaveData?.readOnlyDetailsMobile : registerEntranceLeaveData?.readOnlyDetailsDefault"></app-transport-details>
    }
    @if (clientStatusService?.isMobile ? registerEntranceLeaveData?.editingDetailsMobile != null: registerEntranceLeaveData?.editingDetailsDefault != null) {
      <app-transport-details [transport]="registerEntranceLeaveData?.transport" [mode]="TransportDetailMode.EDITING"
      [layout]="clientStatusService?.isMobile ? registerEntranceLeaveData?.editingDetailsMobile : registerEntranceLeaveData?.editingDetailsDefault"></app-transport-details>
    }
  </sc-padding>

  <sc-flex-fitting-content vertical class="no-field-space">
    <sc-scroll-pane>
      <sc-padding>

        <sc-flex [gap]="32" stretchContent [vertical]="clientStatusService.isMobile">

          <sc-flex-fitting-content [disabled]="clientStatusService.isMobile">
            <app-gate [gates]="registerEntranceLeaveData?.areaGates"
            (selectionChanged)="handleGateSelectionChanged($event)"></app-gate>
            <sc-content-spacer vertical double></sc-content-spacer>

            @if (yardPropertiesService.isWeighingEntranceEnabled() &&
              yardPropertiesService.isWeighingEnabled()) {
              <app-weighing [usage]="registerEntranceLeaveData?.weighingUsage"
                [autoWeighingSource]="registerEntranceLeaveData?.autoWeightSource"
                (valueChanged)="handleWeighingResult($event)"
              (validityChanged)="handleWeighingValidityChanged($event)"></app-weighing>
              <sc-content-spacer vertical double></sc-content-spacer>
            }

            <app-tasks [tasks]="registerEntranceLeaveData?.tasks"
            [transportId]="registerEntranceLeaveData?.transport.id" (changed)="handleTasksChanged()"></app-tasks>

          </sc-flex-fitting-content>

          @if ((cps.isPropertyTrue(TMCClientParameters.FEATURES_COMBINED_ENTRANCE, false) && registerEntranceLeaveData?.direction === 'entrance') ||
            (cps.isPropertyTrue(TMCClientParameters.FEATURES_COMBINED_LEAVE, false) && registerEntranceLeaveData?.direction === 'leave')) {
            <sc-flex-fitting-content [disabled]="clientStatusService.isMobile"
              >
              <app-supplementary-equipment [equipments]="registerEntranceLeaveData?.supplementaryEquipments"
                (changed)="handleSupplementaryEquipmentChange($event)" [direction]="registerEntranceLeaveData?.direction"
                [outhandedEquipments]="registerEntranceLeaveData?.outhandedSupplementaryEquipments"
              (validityChanged)="handleSupplementaryEquipmentValidityChange($event)"></app-supplementary-equipment>
            </sc-flex-fitting-content>
          }

        </sc-flex>

        <sc-content-spacer vertical double></sc-content-spacer>

        <app-hints [checks]="registerEntranceLeaveData?.checks"></app-hints>

      </sc-padding>
    </sc-scroll-pane>
  </sc-flex-fitting-content>

  <sc-padding>
    @if (!clientStatusService.isMobile) {
      <sc-flex>
        <sc-cancel-button (click)="cancel()"></sc-cancel-button>
        <sc-content-spacer grow></sc-content-spacer>
        @if (!registerEntranceLeaveData?.transport.processing.wasRegistered) {
          <form [formGroup]="registerEntranceForm">
            <sc-checkbox-field formControlName="registerArrival"
              labelDictionaryKey="tmc-yard.transport-registration.ui.checkbox.register-arrival"
            formControlName="registerArrival"></sc-checkbox-field>
          </form>
        }
        <sc-content-spacer></sc-content-spacer>
        <sc-button (click)="decline()" [dictionaryKey]="declineButtonDictionaryKey"></sc-button>
        <sc-content-spacer></sc-content-spacer>
        <sc-button (click)="confirm()" [dictionaryKey]="confirmButtonDictionaryKey" primary
        [disabled]="!valid"></sc-button>
      </sc-flex>
    }
    @if (clientStatusService.isMobile) {
      <sc-flex>
        <sc-cancel-button (click)="cancel()"></sc-cancel-button>
        <sc-content-spacer grow></sc-content-spacer>
      </sc-flex>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-flex>
        <sc-button (click)="decline()" [dictionaryKey]="declineButtonDictionaryKey" class="grow"></sc-button>
        <sc-content-spacer></sc-content-spacer>
        <sc-button (click)="confirm()" [dictionaryKey]="confirmButtonDictionaryKey" primary class="grow"
        [disabled]="!valid"></sc-button>
      </sc-flex>
    }
  </sc-padding>

</sc-flex>
